




























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Blog } from '@/models/blog'
import BlogTagChip from '@/components/BlogTagChip.vue'
import ShareDialog from '@/components/ShareDialog.vue'

@Component({
  components: {
    BlogTagChip,
    ShareDialog
  }
})
export default class BlogCard extends Vue {
  @Prop() blog!: Blog
  private dialogOpen = false

  public share () {
    const dialog = this.$refs.shareDialog as ShareDialog
    dialog.toggle(true)
  }
}

